
export const CANDIDATE ="CANDIDATE" 
export const ORGANIZATION ="ORGANIZATION"
export const RECRUITER ="RECRUITER"
export const ADMIN ="ADMIN"